export const environment = {
  production: true,
  taxiUrl: (<any>window).baseUrl,
  baseUrlHub: (<any>window).baseUrlHub,
  cctvEnabled: (<any>window).cctvEnabled,
  encryptionKey: 'sNMELyC8ohN8WF_WRnalirezaHjbMItOVizcscPiWsQJX9hmw'
};

// mapBox_Api = "pk.eyJ1Ijoicm9kcmlnb2thbWFkYSIsImEiOiJjbGZ5NTVhenAwanBzM3Fta3Y3b29temE5In0.PkdHrkHBrx9RALYhyLMRxA"

// mapBox_Layer = [

//   { "url": `https://api.mapbox.com/styles/v1/mapbox/traffic-day-v2/tiles/{z}/{x}/{y}?access_token=${this.mapBox_Api}` },

//   { "url": `https://api.mapbox.com/styles/v1/mapbox/traffic-night-v2/tiles/{z}/{x}/{y}?access_token=${this.mapBox_Api}` },

//   { "url": `https://api.mapbox.com/styles/v1/mapbox/navigation-day-v1/tiles/{z}/{x}/{y}?access_token=${this.mapBox_Api}` },

//   { "url": `https://api.mapbox.com/styles/v1/mapbox/navigation-night-v1/tiles/{z}/{x}/{y}?access_token=${this.mapBox_Api}` },

//   { "url": `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}?access_token=${this.mapBox_Api}` },

//   { "url": `https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v12/tiles/{z}/{x}/{y}?access_token=${this.mapBox_Api}` },

//   { "url": `https://api.mapbox.com/styles/v1/mapbox/light-v11/tiles/{z}/{x}/{y}?access_token=${this.mapBox_Api}` },
// //
//   { "url": `https://api.mapbox.com/styles/v1/mapbox/streets-v8/tiles/{z}/{x}/{y}?access_token=${this.mapBox_Api}` },

//   { "url": `https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=${this.mapBox_Api}` },

//   { "url": `https://api.mapbox.com/styles/v1/mapbox/streets-v12/tiles/{z}/{x}/{y}?access_token=${this.mapBox_Api}` },

//   { "url": `https://api.mapbox.com/styles/v1/mapbox/dark-v11/tiles/{z}/{x}/{y}?access_token=${this.mapBox_Api}` },

//   { "url": `https://api.mapbox.com/styles/v1/mapbox/outdoors-v12/tiles/{z}/{x}/{y}?access_token=${this.mapBox_Api}` },

//   { "url": `OSM` },

// ]